var smartCart = (function () {
    var config = {
        shippingThreshold: 35000, // 350 AED in cents
        moneyFormat: '{{amount}} AED' // Basic format, will be enhanced
    };

    var state = {
        cart: null,
        isLoading: false
    };

    function init() {
        fetchCart();

        // Intercept Add to Cart forms
        document.addEventListener('submit', function (e) {
            if (e.target && e.target.action && e.target.action.includes('/cart/add')) {
                e.preventDefault();
                addToCart(new FormData(e.target));
            }
        });

        // Bind global open buttons
        document.querySelectorAll('.js-call-minicart, a[href="/cart"]').forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                open();
            });
        });
    }

    function open() {
        document.getElementById('smart-cart-drawer').classList.add('open');
        document.getElementById('smart-cart-overlay').classList.add('open');
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
        fetchCart(); // Refresh on open
    }

    function close() {
        document.getElementById('smart-cart-drawer').classList.remove('open');
        document.getElementById('smart-cart-overlay').classList.remove('open');
        document.body.style.overflow = '';
    }

    function fetchCart() {
        // Local Mock Cart check for offline testing
        var stored = localStorage.getItem('local_mock_cart');
        if (stored) {
            var mockCart = JSON.parse(stored);
            if (mockCart && mockCart.items && mockCart.items.length > 0) {
                state.cart = mockCart;
                render();
                return;
            }
        }

        fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
                state.cart = cart;
                render();
            })
            .catch(err => console.error('Error fetching cart:', err));
    }

    function addToCart(formData) {
        fetch('/cart/add.js', {
            method: 'POST',
            body: formData
        })
            .then(res => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error('Item not added');
                }
            })
            .then(item => {
                open(); // Open cart on success
                fetchCart(); // Update cart
            })
            .catch(err => {
                console.error('Error adding to cart:', err);
                alert('Could not add item to cart. Please try again.');
            });
    }

    function changeQty(line, qty) {
        var stored = localStorage.getItem('local_mock_cart');
        if (stored) {
            var mockCart = JSON.parse(stored);
            if (mockCart && mockCart.items && mockCart.items.length > 0) {
                var index = line - 1;
                if (mockCart.items[index]) {
                    if (qty === 0) {
                        mockCart.items.splice(index, 1);
                    } else {
                        mockCart.items[index].quantity = qty;
                        mockCart.items[index].line_price = mockCart.items[index].price * qty;
                    }
                }
                
                // Recalculate totals
                mockCart.item_count = mockCart.items.reduce(function(sum, item) { return sum + item.quantity; }, 0);
                mockCart.total_price = mockCart.items.reduce(function(sum, item) { return sum + (item.price * item.quantity); }, 0);
                localStorage.setItem('local_mock_cart', JSON.stringify(mockCart));
                
                state.cart = mockCart;
                render();
                return;
            }
        }

        fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: line, quantity: qty })
        })
            .then(res => res.json())
            .then(cart => {
                state.cart = cart;
                render();
            })
            .catch(err => console.error('Error changing qty:', err));
    }

    function render() {
        var cart = state.cart;

        // Update Count
        // Update Count in Drawer
        var countEl = document.getElementById('sc-count');
        if (countEl) countEl.innerText = cart.item_count;

        // Update Count in Header (Global)
        var headerCountEls = document.querySelectorAll('.js-cart-count, .cart-count, #CartCount, .enj-cartcount');
        headerCountEls.forEach(function (el) {
            el.innerText = cart.item_count;
        });

        // Update Free Shipping Bar
        var threshold = config.shippingThreshold;
        var total = cart.total_price;
        var remaining = threshold - total;
        var progress = (total / threshold) * 100;
        if (progress > 100) progress = 100;

        var barText = document.getElementById('sc-shipping-text');
        var barFill = document.getElementById('sc-progress-fill');

        if (total >= threshold) {
            barText.innerHTML = '🎉 You have unlocked <strong>FREE SHIPPING!</strong>';
            barFill.style.backgroundColor = '#4CAF50'; // Green for success
        } else {
            var remainingFormatted = formatMoney(remaining);
            barText.innerHTML = 'Spend <strong>' + remainingFormatted + '</strong> more for <strong>FREE SHIPPING!</strong>';
            barFill.style.backgroundColor = '#000';
        }
        barFill.style.width = progress + '%';

        // Render Items
        var itemsList = document.getElementById('sc-items-list');
        var emptyState = document.getElementById('sc-empty-state');
        var footer = document.getElementById('sc-footer');
        var shippingBar = document.getElementById('sc-shipping-bar');

        if (cart.item_count === 0) {
            itemsList.innerHTML = '';
            emptyState.style.display = 'flex';
            footer.style.display = 'none';
            shippingBar.style.display = 'none';
            fetchBestSellers();
        } else {
            emptyState.style.display = 'none';
            footer.style.display = 'block';
            shippingBar.style.display = 'block';

            var html = '';
            var colorMap = {
                'silver': '#E0E0E0',
                'pink': '#F2A8B8',
                'rose': '#E6BEBE',
                'rose-gold': '#D69886',
                'gold': '#E6C885',
                'periwinkle': '#8DA3D4',
                'lilac': '#CDCBE6',
                'white': '#F5F5F0',
                'brown': '#A05548',
                'camel': '#CD854F',
                'dark-green': '#3E5F63',
                'navy-blue': '#404860',
                'slate-blue': '#658398'
            };

            cart.items.forEach(function (item, index) {
                var img = item.image ? item.image : '//placehold.it/100x100';
                var variant = item.variant_title ? item.variant_title : '';

                // Process Properties
                var propertiesHtml = '';
                if (item.properties) {
                    Object.keys(item.properties).forEach(function (key) {
                        var value = item.properties[key];
                        if (value && key.charAt(0) !== '_') {
                            var swatchHtml = '';
                            if (key.toLowerCase().indexOf('color') > -1) {
                                var handle = value.toLowerCase().trim().replace(/\s+/g, '-');
                                if (colorMap[handle]) {
                                    swatchHtml = `<span class="sc-color-swatch" style="display: inline-block; width: 12px; height: 12px; border-radius: 2px; border: 1px solid #ddd; vertical-align: middle; margin-left: 5px; background-color: ${colorMap[handle]};"></span>`;
                                }
                            }
                            propertiesHtml += `<div class="sc-item-property"><strong>${key}:</strong> ${value}${swatchHtml}</div>`;
                        }
                    });
                }

                // Template literal replacement
                var itemHtml = document.getElementById('sc-item-template').innerHTML
                    .replace(/\$\{line\}/g, index + 1)
                    .replace(/\$\{img\}/g, img)
                    .replace(/\$\{title\}/g, item.product_title)
                    .replace(/\$\{url\}/g, item.url)
                    .replace(/\$\{variant\}/g, variant)
                    .replace(/\$\{properties\}/g, propertiesHtml)
                    .replace(/\$\{qty\}/g, item.quantity)
                    .replace(/\$\{price\}/g, formatMoney(item.line_price));

                html += itemHtml;
            });
            itemsList.innerHTML = html;
        }

        // Update Subtotal
        document.getElementById('sc-subtotal').innerText = formatMoney(cart.total_price);
    }

    function fetchBestSellers() {
        var container = document.getElementById('sc-recommendations');
        var list = document.getElementById('sc-rec-list');

        if (list.children.length > 0) {
            container.style.display = 'block';
            return; // Already fetched
        }

        fetch('/collections/all/products.json?limit=3')
            .then(res => res.json())
            .then(data => {
                if (data.products && data.products.length > 0) {
                    var html = '';
                    data.products.forEach(function (product) {
                        var img = product.images.length > 0 ? product.images[0].src : '//placehold.it/60x60';
                        var price = product.variants[0].price;
                        html += `
              <div class="sc-rec-item">
                <img src="${img}" class="sc-rec-img" alt="${product.title}">
                <div class="sc-rec-info">
                  <a href="/products/${product.handle}" class="sc-rec-name">${product.title}</a>
                  <div class="sc-rec-price">Dhs. ${price}</div>
                </div>
              </div>
            `;
                    });
                    list.innerHTML = html;
                    container.style.display = 'block';
                }
            });
    }

    function formatMoney(cents) {
        return (cents / 100).toFixed(2) + ' AED';
    }

    return {
        init: init,
        open: open,
        close: close,
        changeQty: changeQty
    };
})();

document.addEventListener('DOMContentLoaded', function () {
    smartCart.init();
});
